export default __webpack_public_path__ + "static/media/8.62d7c334.png";